import { api } from "@/plugins/api";

const state = {
  users: [],
};

const getters = {
  getAllUsers: (state) => state.users,

  getUserById: (state) => (id) => state.users.filter((user) => user.id === id),

  // getActiveStudents: (state) =>
  //   state.users.filter(
  //     (user) =>
  //       (user.userType === "student" || user.userType === "team") &&
  //       user.status === "active"
  //   ),
};

const actions = {
  async fetchAllUsers({ commit }) {
    try {
      const response = await api.get("/users");
      const users = response.data.data;
      commit("setUsers", users);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async addUser({ commit }, user) {
    try {
      //console.log("passed data", user);
      const response = await api.post("/users", user);
      //console.log("response", response);
      commit("addUser", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async updateUser({ commit }, user) {
    try {
      const id = user.id;
      //console.log("passed data", user);
      user._method = "put";
      const response = await api.post(`/users/${id}`, user);
      //console.log("updated", response.data);
      commit("updateUser", response.data.data);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async activateUser({ commit }, id) {
    try {
      const response = await api.patch(`/users/${id}/activate`);
      commit("updateUser", response.data.user);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async blockUser({ commit }, id) {
    try {
      const response = await api.patch(`/users/${id}/block`);
      commit("updateUser", response.data.user);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async deleteUser({ commit }, id) {
    try {
      //const response = await api.delete(`/users/${id}`);
      const response = await api.delete(`/users/${id}`);
      console.log("response", response);
      if (response) {
        commit("removeUser", id);
      }
      //return response.data.message;
      return true;
    } catch (error) {
      //console.log("response", error);
      //return error.message;
      return false;
    }
  },
};

const mutations = {
  setUsers(state, users) {
    state.users = users;
    //console.log("mu", state.users);
  },
  addUser(state, user) {
    //console.log("uses is:", user);
    state.users.unshift(user);
    //console.log("uses updated:", state.users);
  },
  removeUser(state, id) {
    const index = state.users.findIndex((user) => user.id == id);
    if (index !== -1) {
      state.users.splice(index, 1);
    }
  },
  updateUser(state, user) {
    const id = user.id;
    const index = state.users.findIndex((user) => user.id == id);
    if (index !== -1) {
      state.users[index] = user;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
